import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { DatewiseEvents } from '../../calendar/models/datewise-events';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../../../../utils/app-settings';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class TimetableService {

  constructor(private http: HttpClient
    , private datepipe: DatePipe) { }

  private http_fetched = false;
  private _timetable: ReplaySubject<Array<DatewiseEvents>> = new ReplaySubject<Array<DatewiseEvents>>(1);
  private timetable$ = this._timetable.asObservable();

  getTimetableByDateRange(start_date: Date, end_date: Date): Observable<Array<DatewiseEvents>> {
    let strStartDate = this.datepipe.transform(start_date, "yyyy-MM-dd");
    let strEndDate = this.datepipe.transform(end_date, "yyyy-MM-dd");
    if (!this.http_fetched) {
      this.http_fetched = true;
      this.http.get<Array<DatewiseEvents>>(AppSettings.apiUrl + "events/GetTimetableByDateRange?startDate=" + strStartDate + "&endDate=" + strEndDate)
        .subscribe(res => {
          this._timetable.next(res);
        }, error => {
          console.error(error);
        });
    }
    return this.timetable$;
  }
}
